module.exports = __webpack_public_path__ + "static/media/reseller-logo-1.c006fa08.png";